module.exports = __webpack_public_path__ + "img/1553004394-mercedes-sprinter.png.c857b15e.webp";